export const WORK_HOURS = {
  startTime: "08:00",
  endTime: "23:59",
};
